module.exports = __webpack_public_path__ + "static/media/maf-27.364cbe0f.png";